import React, { useMemo } from 'react';
import { Graphic } from '@ligr/themes';
import { OverlayContainer } from '../../lib/overlayContainer';
import { DelayedSummary } from '../../lib/delayedSummaryContainer';
import { ClockContainer } from '../../lib/clockContainer';
import camelcase from 'camelcase';
import { DesiredGfxState } from '../../lib/useGfxState';
import { getCurrentPeriod, getNextPeriod } from '@ligr/shared';
// @ts-ignore
import DeltaE from 'delta-e';
// @ts-ignore
import convert from 'color-convert';
const switchTeamColorsIfNecessary = ({ homeTeam, awayTeam }) => {
    if (!homeTeam || !awayTeam) {
        return { homeTeam, awayTeam };
    }
    const homePrimary = convert.hex.lab(homeTeam.primaryBackgroundColor);
    const awayPrimary = convert.hex.lab(awayTeam.primaryBackgroundColor);
    const delta = DeltaE.getDeltaE00({ L: homePrimary[0], A: homePrimary[1], B: homePrimary[2] }, { L: awayPrimary[0], A: awayPrimary[1], B: awayPrimary[2] });
    if (delta < 8.5) {
        if (awayTeam.secondaryBackgroundColor && awayTeam.secondaryTextColor) {
            return {
                homeTeam,
                awayTeam: Object.assign(Object.assign({}, awayTeam), { primaryBackgroundColor: awayTeam.secondaryBackgroundColor, primaryTextColor: awayTeam.secondaryTextColor })
            };
        }
        return {
            homeTeam,
            awayTeam: Object.assign(Object.assign({}, awayTeam), { primaryBackgroundColor: awayTeam.primaryTextColor, primaryTextColor: awayTeam.primaryBackgroundColor })
        };
    }
    return { homeTeam, awayTeam };
};
const useLatestData = () => {
    const overlayContainer = OverlayContainer.useContainer();
    const match = overlayContainer.match;
    const summaryContainer = DelayedSummary.useContainer();
    const matchSummary = summaryContainer.data.matchSummary;
    const facts = summaryContainer.facts;
    const { clockData } = ClockContainer.useContainer();
    const { homeTeam, awayTeam } = switchTeamColorsIfNecessary(match);
    return useMemo(() => ({
        homeTeam,
        lineup: match.lineup,
        awayTeam,
        summary: matchSummary,
        // @ts-ignore
        stats: matchSummary === null || matchSummary === void 0 ? void 0 : matchSummary.matchStats,
        match,
        clockData,
        venue: match === null || match === void 0 ? void 0 : match.venue,
        currentPeriod: getCurrentPeriod(matchSummary),
        nextPeriod: getNextPeriod(matchSummary),
        facts
    }), [match, matchSummary, clockData]);
};
export const GraphicWrapper = ({ forceAnimationResetPaths, name, template, zIndex, triggerToGraphicData, animationList, adTransformObject, fieldDataSpec, getAnimPath, delayMap, noAnimation }) => {
    const { state: { desiredState: overlayDesiredState } } = DesiredGfxState.useContainer();
    const graphicDesiredState = overlayDesiredState[camelcase(name)];
    // here we want to encapsulate the behaviour in which an automation event is converted to
    // the needed graphic props.
    // There should be a data function for each graphic type that facilitates this.
    // console.log(name, JSON.stringify(graphicDesiredState));
    const data = useLatestData();
    // console.log(data);
    return (React.createElement(Graphic, { zIndex: zIndex, triggerToGraphicData: triggerToGraphicData, forceAnimationResetPaths: forceAnimationResetPaths, noAnimation: noAnimation, name: name, adTransformObject: adTransformObject, delayMap: delayMap, fieldDataSpec: fieldDataSpec, animationList: animationList, graphicProps: graphicDesiredState, template: template, getAnimPath: getAnimPath, latestData: data }));
};
//# sourceMappingURL=index.js.map